import React from 'react';
import { Reveal } from './Reveal';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  tone = 'light',
  align = 'left'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <Reveal className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-294" data-mp="3k29jk5a4u4yr">
      <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-295" data-mp="bl5a6lnw965d">
        <span className="h-px w-8 bg-gold" aria-hidden="true" data-id="element-296" data-mp="gioo1kgojgws" />
        <p className={`eyebrow ${dark ? 'text-gold-light' : 'text-royal'}`} data-id="element-297" data-mp="1vbzdmvksv26">{eyebrow}</p>
      </div>
      <h2 className={`mt-5 font-display text-3xl font-light leading-[1.15] tracking-tight sm:text-4xl lg:text-[2.75rem] ${dark ? 'text-white' : 'text-navy'}`} data-id="element-298" data-mp="6svgqvnklnyc">
        {title}
      </h2>
      {description ? <p className={`mt-5 text-base leading-relaxed ${dark ? 'text-slate-300' : 'text-charcoal/75'}`} data-id="element-299" data-mp="zc101d8shr9z">
          {description}
        </p> : null}
    </Reveal>;
}